import React, { useState, useEffect } from "react";
import { Alert, Result } from "antd";
import MainWrapper from "../../components/MainWrapper";
import WarningModal from "../../components/WarningModal";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { useParams } from "react-router-dom";
import AlertMessageWrapper from "../../components/AlertMessageWrapper";
import ButtonWrapper from "../../components/ButtonWrapper";
import OnePayTransactionInfoCard from "./OnePayTransactionInfoCard";

const OnePayTransactionInfo = (props) => {
  const params = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // const [lang, setLang] = useState("th");
  const { isLoading, error } = useSelector(
    (state) => state.getVerifyManualTransactionReducer
  );

  const { lang } = useSelector((state) => state.languageSelectorReducer);

  const postQrInitManualState = useSelector(
    (state) => state.postQrInitManualReducer
  );
  const {
    data: qrInitData,
    error: qrInitError,
    isLoading: qrInitLoading,
  } = postQrInitManualState;

  const warningModalState = useSelector((state) => state.warningModalReducer);
  const { modalShow, data } = warningModalState;

  // useEffect(() => {
  //   dispatch(getVerifyManualTransactionFunc(params.id, 'vnd'));
  // }, []);

  const errorMessage = () => {
    if (error) {
      return (
        <div className="d-flex flex-column justify-content-center align-items-center">
          <Result
            status="500"
            extra={
              <>
                <AlertMessageWrapper message={error} />
                <ButtonWrapper
                  onClick={() => window.location.reload()}
                  border={false}
                  className="mt-3"
                  text="Refresh"
                  height="40px"
                  fontSize="16px"
                  type="primary"
                />
              </>
            }
          />
        </div>
      );
    } else if (qrInitError == "Error: auto trx id is not valid or expired") {
      return (
        <div className="d-flex flex-column justify-content-center align-items-center">
          <Result
            status="500"
            extra={
              <AlertMessageWrapper message={"ธุรกรรมนี้มีอยู่แล้วในระบบ"} />
            }
          />
        </div>
      );
    } else if (
      qrInitError == "ConflictException: Qr Code status has been changed"
    ) {
      return (
        <div className="d-flex flex-column justify-content-center align-items-center">
          <Result
            status="500"
            extra={
              <AlertMessageWrapper
                message={"รหัส QR ไม่พร้อมใช้งาน กรุณาติดต่อเจ้าหน้าที่"}
              />
            }
          />
        </div>
      );
    } else if (qrInitError) {
      return (
        <div className="d-flex flex-column justify-content-center align-items-center">
          <Result
            status="500"
            extra={
              <>
                <AlertMessageWrapper message={qrInitError} />
                <ButtonWrapper
                  border={false}
                  onClick={() => window.location.reload()}
                  className="mt-3"
                  text="Refresh"
                  height="40px"
                  fontSize="16px"
                  type="primary"
                />
              </>
            }
          />
        </div>
      );
    }
  };

  useEffect(() => {
    errorMessage();
  }, [qrInitError, error]);

  return (
    <div className="" style={{ minHeight: "100dvh" }}>
      {modalShow && (
        <WarningModal
          visible={modalShow}
          lang={lang}
          closeIcon={<span></span>}
          maskClosable={false}
          // centered={true}
          footer={null}
          bodyStyle={{ borderRadius: 10 }}
          width={370}
        />
      )}
      <MainWrapper>
        {/* {isLoading ? (
          <SpinerIndicator fontSize="50px" color="#fff" />
        ) : error || qrInitError ? (
          errorMessage()
        ) : ( */}
          <OnePayTransactionInfoCard lang={lang} />
        {/* )} */}
      </MainWrapper>
    </div>
  );
};

export default OnePayTransactionInfo;
